import React from "react";
import Styles from './index.module.scss';

const Spinner = () => (
    <div className={Styles.wrapper}>
        <div className={Styles.profileMainLoader}>
            <div className={Styles.loader}>
                <svg className={Styles.circularLoader} viewBox="25 25 50 50" >
                    <circle className={Styles.loaderPath} cx="50" cy="50" r="20" fill="none" stroke="#70c542" stroke-width="2" />
                </svg>
            </div>
        </div>

    </div>
);

export default Spinner;